import * as actionTypes from 'actions';

const initialState = {
    users: {}
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ALL_USERS: {
            return {
                ...initialState,
                users: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default userReducer;
